// extracted by mini-css-extract-plugin
export default {"hub_card":"p0","img":"q0","title":"r0","button":"s0","account_hub_card":"t0","label":"u0"};
    if(module.hot) {
      // 1715276859875
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  